import React, { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import "../App.css";
import { toast } from "react-toastify";
import { ownerLogout, updateStoreTraffic } from "../redux/actions/authAction";
import { getStore } from "../redux/actions/storeAction";
import { Modal } from "react-bootstrap";
import { io } from "socket.io-client";
import chill from "../assets/images/chill.svg";
import fire from "../assets/images/fire.svg";
import vibrant from "../assets/images/vibrant.svg";
import Dashboard from "./dashboard";

const init = {
  timeArray: [
    "1:00:00 AM","2:00:00 AM","3:00:00 AM","4:00:00 AM","5:00:00 AM",
    "6:00:00 AM","7:00:00 AM","8:00:00 AM","9:00:00 AM","10:00:00 AM",
    "11:00:00 AM","12:00:00 PM","1:00:00 PM","2:00:00 PM","3:00:00 PM",
    "4:00:00 PM","5:00:00 PM","6:00:00 PM","7:00:00 PM","8:00:00 PM",
    "9:00:00 PM","10:00:00 PM","11:00:00 PM","12:00:00 AM",
  ]
};

const Header = () => {
  const [iState] = useState(init);
  const { timeArray } = iState;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { storeData } = useSelector((state) => state.store);
  const [trafficeShow, updatetrafficeShow] = useState(false);

  const handleTrafficClose = () => updatetrafficeShow(false);
  const handleTrafficShow = () => updatetrafficeShow(true);

  const storeid = JSON.parse(localStorage.getItem("ownerLogin"))?._id;

  const socketRef = useRef(null);
  const SOCKET_SERVER_URL = "https://bayin.app:4000";



  // ------------------ FIXED INTERVAL ------------------ //
  useEffect(() => {
    const interval = setInterval(() => {
      const timeNow = new Date().toLocaleTimeString();
      if (timeArray.includes(timeNow)) {
        handleTrafficShow();
      }
    }, 1000);

    return () => clearInterval(interval); // cleanup
  }, [timeArray]);

  // ------------------ GET STORE DATA ------------------ //
  // useEffect(() => {
  //   dispatch(getStore({})).then((res) => {
  //     if (res.status === 200) {
  //     }

  //     if (res.status === 503) {
  //       socketRef.current = io(SOCKET_SERVER_URL, {
  //         transports: ["websocket"],
  //         reconnection: true,
  //         reconnectionAttempts: Infinity,
  //         reconnectionDelay: 1000,
  //         reconnectionDelayMax: 5000,
  //       });

  //       socketRef.current.on("disconnect", () => {
  //         console.log("Socket disconnected");
  //       });

  //       socketRef.current.disconnect();
  //       localStorage.clear();
  //       navigate("/");
  //       toast.error("Logging out. User is already logged in somewhere.");
  //     }
  //   });
  // }, []);

  // ------------------ LOGOUT ------------------ //
  const handleLogout = () => {
    dispatch(ownerLogout()).then((res) => {
      if (res.status === 200) {
        toast.success(res.message);
        localStorage.clear();
        navigate("/");
      } else {
        toast.error(res.message);
        navigate("/");
      }
    });
  };

  // ------------------ SEND TRAFFIC ------------------ //
  const sendTraffice = (traffic) => {
    dispatch(updateStoreTraffic({ _id: storeid, traffic }));
    updatetrafficeShow(false);
  };

  return (
    <div>
      <div className="Header">
        <div className="Navigation">
          <div className="Avater">
            <Link to="">
              <figure>
                <img src={storeData?.data?.logo} alt="" />
              </figure>
              {storeData?.data?.storeName}
            </Link>

            <ul>
              <li>
                <figure>
                  <img src={storeData?.data?.logo} alt="" />
                </figure>
                <h4>{storeData?.data?.storeName}</h4>
              </li>

              <li>
                <button
                  onClick={handleLogout}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: "#fff",
                  }}
                >
                  <i className="fa fa-sign-out"></i> Logout
                </button>
              </li>
            </ul>
          </div>

          <div className="clear"></div>
      
        </div>

   

        <Modal show={trafficeShow} onHide={handleTrafficClose} className="ModalBox">
          <Modal.Body>
            <div className="Decline">
              <button className="CloseModal" onClick={handleTrafficClose}>
                ×
              </button>

              <div className="StoreTrafic">
                <h4>Store Traffic</h4>
                <ul>
                  <li>
                    <button onClick={() => sendTraffice(50)}>
                      <img src={chill} alt="" /> <span>Chill</span>
                    </button>
                  </li>
                  <li>
                    <button onClick={() => sendTraffice(100)}>
                      <img src={vibrant} alt="" /> <span>Vibrant</span>
                    </button>
                  </li>
                  <li>
                    <button onClick={() => sendTraffice(150)}>
                      <img src={fire} alt="" /> <span>Fire</span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default Header;
